"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masterDataInformationFields = exports.dataFields = void 0;
exports.dataFields = [
    {
        column_name: 'iso_3166',
        data_type: 'string',
        is_nullable: false,
    },
    {
        column_name: 'orgnr',
        data_type: 'orgnr',
        is_nullable: false,
    },
    {
        column_name: 'company_master_sys_period',
        data_type: 'tstzrange',
        is_nullable: false,
    },
    {
        column_name: 'likelihood_to_move_score',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'legal_entity_type',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'address',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'zipcode',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'city',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'muncipality',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'county',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'region',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'website',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'phone',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'email',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'registration_date',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'company_category',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'company_structure',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'legal_form',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'listing_type',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'description_en',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'operational_status',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'owners',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'key_persons',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'signatory',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'parent_company_name',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'previous_names',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'accountant_firm',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'has_private_equity_owner',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'private_equity_owner',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'lfy',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'lrq',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'ceo',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'ceo_birth_year',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'chairman',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'chairman_birth_year',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'has_share_issues',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'number_of_owners',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'number_of_shares',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'has_foreign_ultimate_parent',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'ultimate_parent_company',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'ultimate_parent_org_no',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'ultimate_parent_net_sales',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'company_name',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'sni_classification',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'sni_classification_code',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'financials_updated_date',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'last_updated',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'company_keywords',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'fiscal_year',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'currency',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'net_sales',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cost_of_sales',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'gross_profit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'administrative_expenses',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'selling_expenses',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'other_external_expenses',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'personel_expenses',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebita',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebitd',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebitda',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'depr_amo',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'depreciation',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'amortisation',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_financial_income_or_expenses',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'financial_income',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'financial_expenses',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'pre_tax_profit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_profit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cash_equivalents',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'acc_rec',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'inventories',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'oth_curr_op_ass',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'curr_fin_ass',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'total_current_assets',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ppe',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'goodwill_intang_ass',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'n_curr_fin_rec',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'oth_n_curr_op_ass',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'total_non_current_assets',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'total_assets',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'acc_pay',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'curr_fin_liab',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'post_empl_liab',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'oth_curr_op_liab',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'total_current_liabilities',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'oth_n_curr_op_liab',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'n_curr_fin_liab',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'total_non_curr_liab',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'sharehold_eq',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'retained_earnings',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'min_int',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'total_equity',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'dividends',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cash_flow_before_fin_act',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cash_flow_operating',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebit_margin',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebitda_margin',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'pre_tax_profit_margin',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_profit_margin',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'roe',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_capex',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_debt',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'market_cap',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'annual_report_number_of_employees',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'fiscal_year_length',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'lfy_month',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'net_change_in_cash',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_sales_growth',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cagr',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cagr3',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebit_growth',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cagr3ebit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'cagrebit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ebitda_growth',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_profit_growth',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'eps',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'equity_ratio',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_debt_to_ebit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_debt_to_ebitda',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'net_debt_to_equity',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ev_to_ebit',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ev_to_ebitda',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ev_to_net_sales',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'pe',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ev',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'pbv',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'annual_report_employee_growth',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'active_jobposts',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'domain_is_verified',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'domain',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'final_url',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'error',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'page_load_time_tti',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'domain_sys_period',
        data_type: 'tstzrange',
        is_nullable: true,
    },
    {
        column_name: 'ip_address',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'analytics_ua',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'analytics_ga4',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'analytics_fb',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'gconvp_account',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'adobe_account',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'org_image',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'sitemaps',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'cookie_consent',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'platform',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'server',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'host',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'domain_keywords',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'description',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'description_words',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'description_chars',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'is_ecommerce',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'ecommerce_platform',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'tool_cookiebot',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_cookielaw',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_onetrust',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_doubleclick',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_hotjar',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_optimizely',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_ebbot',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_intercom',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_klaviyo',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_hubspot',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_marketo',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_salesforce',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_trustpilot',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_custobar',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_voyado',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_godaddy',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_shopify',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_squarespace',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_wix',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_wordpress',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_seenthis',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_yotpo',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_apprl',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_criteo',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'tool_reco',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'requested_hosts',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'analytics_gtm',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'analytics_aw',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'tool_googletagmanager',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'size_document',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_script',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_stylesheet',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_image',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_media',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'title',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'title_words',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'title_chars',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'favicon',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'canonical',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'robots',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'noindex',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'internal_links',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'external_links',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'analytics_mo',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'lang',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'analytics_adobe',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'colors_font',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'colors_page',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'colors_svg',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'access_violation_score',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'violations',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'img_alt_ratio',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'analytics_opt',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'analytics_amplitude',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'analytics_snowplow',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'trackers_before_consent',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'trackers_before_consent_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'web_vitals_ttfb',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'web_vitals_fcp',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'web_vitals_lcp',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'web_vitals_cls',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'web_vitals_tti',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'detected_languages',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'language_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'h_1_content',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'h_1_content_words',
        data_type: 'numeric-array', // or 'number-array' if that is your convention
        is_nullable: true,
    },
    {
        column_name: 'h_1_content_chars',
        data_type: 'numeric-array', // or 'number-array'
        is_nullable: true,
    },
    {
        column_name: 'h_1_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'h_2_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'h_3_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'sitemap',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'sitemap_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'sitemap_url_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'dns_a',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'dns_aaaa',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'dns_ns',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'dns_soa',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_mx',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'email_provider',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'hosting_provider',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'hosting_region',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_spf',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'dns_dmarc',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'dns_dmarc_level',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_dmarc_details',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_dkim',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'dns_dkim_selector',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_dkim_level',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_dkim_details',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'dns_verifications',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'size_font',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_xhr',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_ping',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_fetch',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'size_other',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'x_robots_tag',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'framework',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'cookies',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'has_schema_script',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'img_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'img_alt_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'img_missing_alt_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'img_title_count',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'snapchat_handle',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_is_verified',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_id',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_domain',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_industry',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_number_of_employees',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_all_employee_growth_3_months',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_all_employee_growth_6_months',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_all_employee_growth_1_year',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'linkedin_all_employee_growth_2_years',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'number_of_employees',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'number_of_employees_source',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_count',
        data_type: 'integer',
        is_nullable: false,
    },
    {
        column_name: 'company_buzz_is_raising_capital',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_ipo',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_merger',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_moving',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_hiring',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_firing',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_closing',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_opening',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_expanding',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_downsizing',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_restructuring',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_new_product_intro',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_has_moved',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_changing_ceo',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_changing_board',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'company_buzz_is_changing_management_team',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'ml_likely_to_move_probability',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'ml_is_likely_to_move',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'move_in_date_current_office',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'move_date_or_lease_expiration_date',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'move_date_or_lease_expiration_date_is_within_one_year',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'move_date_or_lease_expiration_date_has_passed',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'is_more_than_5_years_since_move_in_date_current_office',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'workspace_size_in_m2',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'workspace_size_in_m2_per_employee',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_web_visitors_lead_quality',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_web_visitors_number_of_visits',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_web_visitors_country_code',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_web_visitors_last_visit_date',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_web_visitors_first_visit_date',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'active_jobposts_per_employee',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_phone',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_city',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_description',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_company_type',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_industry',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_continent',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sence_employee_range',
        data_type: 'numeric-array',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_naics',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_products_or_services',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_sic',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_stock_exchange',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_stock_symbol',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_web_technologies',
        data_type: 'string-array',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_total_funding_range',
        data_type: 'string',
        is_nullable: true,
    },
    {
        column_name: '_6_sense_year_founded',
        data_type: 'integer',
        is_nullable: true,
    },
    {
        column_name: 'percent_employees_with_more_than_10_years_experience',
        data_type: 'numeric',
        is_nullable: true,
    },
    {
        column_name: 'has_on_site_requirements',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'recent_funding',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_keyword_search',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_researched_office',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_researched_furniture',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'looking_for_office',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'is_sitting_on_co_working_space',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'lease_expiration_date',
        data_type: 'date',
        is_nullable: true,
    },
    {
        column_name: 'lease_expiration_date_is_within_one_year',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'nornorm_website_visitor',
        data_type: 'boolean',
        is_nullable: true,
    },
    {
        column_name: 'number_of_addresses',
        data_type: 'integer',
        is_nullable: true,
    },
];
exports.masterDataInformationFields = [
    {
        section: 'Company columns',
        translation: 'Country',
        key: 'iso3166',
        type: 'string',
        nullable: false,
    },
    {
        section: 'general',
        translation: 'Organization number',
        key: 'orgnr',
        type: 'string',
        nullable: false,
    },
    {
        section: '',
        translation: 'Company Master Sys Period',
        key: 'companyMasterSysPeriod',
        type: 'unknown',
        nullable: false,
    },
    {
        section: '',
        translation: 'Likelihood To Move Score',
        key: 'likelihoodToMoveScore',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Legal entity type',
        key: 'legalEntityType',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Address',
        key: 'address',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Zipcode',
        key: 'zipcode',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'City',
        key: 'city',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Muncipality',
        key: 'muncipality',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'County',
        key: 'county',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Region',
        key: 'region',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Website',
        key: 'website',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Phone',
        key: 'phone',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Email',
        key: 'email',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Registration date',
        key: 'registrationDate',
        type: 'date',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Company category',
        key: 'companyCategory',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Company structure',
        key: 'companyStructure',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Legal form',
        key: 'legalForm',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Listing type',
        key: 'listingType',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Description EN',
        key: 'descriptionEn',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Operational status',
        key: 'operationalStatus',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Owners',
        key: 'owners',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Key persons',
        key: 'keyPersons',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Signatory',
        key: 'signatory',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Parent company name',
        key: 'parentCompanyName',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Previous names',
        key: 'previousNames',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Accountant firm',
        key: 'accountantFirm',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Has private equity owner',
        key: 'hasPrivateEquityOwner',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Private equity owner',
        key: 'privateEquityOwner',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'LFY',
        key: 'lfy',
        type: 'date',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'LRQ',
        key: 'lrq',
        type: 'date',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'CEO',
        key: 'ceo',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'CEO birth year',
        key: 'ceoBirthYear',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Chairman',
        key: 'chairman',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Chairman birth year',
        key: 'chairmanBirthYear',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Has Share issues',
        key: 'hasShareIssues',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Number of owners',
        key: 'numberOfOwners',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Number of shares',
        key: 'numberOfShares',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Has Foreign ultimate parent',
        key: 'hasForeignUltimateParent',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Ultimate parent company',
        key: 'ultimateParentCompany',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Ultimate parent org no',
        key: 'ultimateParentOrgNo',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Ultimate parent net sales',
        key: 'ultimateParentNetSales',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Company name',
        key: 'companyName',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'SNI classification',
        key: 'sniClassification',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'SNI classification code',
        key: 'sniClassificationCode',
        type: 'string',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Financials updated date',
        key: 'financialsUpdatedDate',
        type: 'date',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Last updated',
        key: 'lastUpdated',
        type: 'date',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Company keywords',
        key: 'companyKeywords',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Fiscal Year',
        key: 'fiscalYear',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Currency',
        key: 'currency',
        type: 'string',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Sales',
        key: 'netSales',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Cost Of Sales',
        key: 'costOfSales',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Gross Profit',
        key: 'grossProfit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Administrative Expenses',
        key: 'administrativeExpenses',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Selling Expenses',
        key: 'sellingExpenses',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Other External Expenses',
        key: 'otherExternalExpenses',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Personel Expenses',
        key: 'personelExpenses',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBIT',
        key: 'ebit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBITA',
        key: 'ebita',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBITD',
        key: 'ebitd',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBITDA',
        key: 'ebitda',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Depr. Amount',
        key: 'deprAmo',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Depreciation',
        key: 'depreciation',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Amortisation',
        key: 'amortisation',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Financial Income Or Expenses',
        key: 'netFinancialIncomeOrExpenses',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Financial Income',
        key: 'financialIncome',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Financial Expenses',
        key: 'financialExpenses',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Pre Tax Profit',
        key: 'preTaxProfit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Profit',
        key: 'netProfit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Cash Equivalents',
        key: 'cashEquivalents',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Acc Rec',
        key: 'accRec',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Inventories',
        key: 'inventories',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Oth Curr Op Ass',
        key: 'othCurrOpAss',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Curr Fin Ass',
        key: 'currFinAss',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Total Current Assets',
        key: 'totalCurrentAssets',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'PPE',
        key: 'ppe',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Goodwill Intang Ass',
        key: 'goodwillIntangAss',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'N Curr Fin Rec',
        key: 'nCurrFinRec',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Oth N Curr Op Ass',
        key: 'othNCurrOpAss',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Total Non Current Assets',
        key: 'totalNonCurrentAssets',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Total Assets',
        key: 'totalAssets',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Accounts Receivable',
        key: 'accPay',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Curr Fin Liab',
        key: 'currFinLiab',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Post Empl Liab',
        key: 'postEmplLiab',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Oth Curr Op Liab',
        key: 'othCurrOpLiab',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Total Current Liabilities',
        key: 'totalCurrentLiabilities',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Oth Non Curr Op Liab',
        key: 'othNCurrOpLiab',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'N Curr Fin Liab',
        key: 'nCurrFinLiab',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Total Non Curr Liab',
        key: 'totalNonCurrLiab',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Sharehold Eq',
        key: 'shareholdEq',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Retained Earnings',
        key: 'retainedEarnings',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Minority Interest',
        key: 'minInt',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Total Equity',
        key: 'totalEquity',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Dividends',
        key: 'dividends',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Cash Flow Before Fin Act',
        key: 'cashFlowBeforeFinAct',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Cash Flow Operating',
        key: 'cashFlowOperating',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBIT Margin',
        key: 'ebitMargin',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBITDA Margin',
        key: 'ebitdaMargin',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Pre Tax Profit Margin',
        key: 'preTaxProfitMargin',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Profit Margin',
        key: 'netProfitMargin',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'ROE',
        key: 'roe',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Capex',
        key: 'netCapex',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Debt',
        key: 'netDebt',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Market Cap',
        key: 'marketCap',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Annual Report Number Of Employees',
        key: 'annualReportNumberOfEmployees',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Fiscal Year Length',
        key: 'fiscalYearLength',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'LFY Month',
        key: 'lfyMonth',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Change In Cash',
        key: 'netChangeInCash',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Sales Growth',
        key: 'netSalesGrowth',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'CAGR',
        key: 'cagr',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'CAGR (3Y)',
        key: 'cagr3',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBIT Growth',
        key: 'ebitGrowth',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBIT CAGR (3Y)',
        key: 'cagr3ebit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBIT CAGR',
        key: 'cagrebit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EBITDA Growth',
        key: 'ebitdaGrowth',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Profit Growth',
        key: 'netProfitGrowth',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EPS',
        key: 'eps',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Equity Ratio',
        key: 'equityRatio',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Debt To EBIT',
        key: 'netDebtToEbit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Debt To EBITDA',
        key: 'netDebtToEbitda',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Net Debt To Equity',
        key: 'netDebtToEquity',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EV To EBIT',
        key: 'evToEbit',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EV To EBITDA',
        key: 'evToEbitda',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EV To Net Sales',
        key: 'evToNetSales',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'PE',
        key: 'pe',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'EV',
        key: 'ev',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'PBV',
        key: 'pbv',
        type: 'number',
        nullable: true,
    },
    {
        section: 'financial',
        translation: 'Annual Report Employee Growth',
        key: 'annualReportEmployeeGrowth',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Jobposts',
        translation: 'Active jobposts',
        key: 'activeJobposts',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Domain is verified',
        key: 'domainIsVerified',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Domain',
        key: 'domain',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Final URL',
        //@ts-ignore
        key: 'finalUrl',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Error',
        key: 'error',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Page load time (tti)',
        key: 'pageLoadTimeTti',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'Domain Sys Period',
        key: 'domainSysPeriod',
        type: 'unknown',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'IP address',
        key: 'ipAddress',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics UA',
        key: 'analyticsUa',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics GA4',
        key: 'analyticsGa4',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics Meta',
        key: 'analyticsFb',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'GCONVP Account',
        key: 'gconvpAccount',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Adobe account',
        key: 'adobeAccount',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Org Image',
        key: 'orgImage',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Sitemaps',
        key: 'sitemaps',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Sitemap',
        key: 'sitemap',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Number of pages',
        key: 'sitemapUrlCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Cookie consent',
        key: 'cookieConsent',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Platform',
        key: 'platform',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Server',
        key: 'server',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Host',
        key: 'host',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Domain keywords',
        key: 'domainKeywords',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Description words',
        key: 'descriptionWords',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Description chars',
        key: 'descriptionChars',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Is eCommerce',
        // @ts-ignore
        key: 'isEcommerce',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'eCommerce platform',
        // @ts-ignore
        key: 'ecommercePlatform',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Title chars',
        key: 'titleChars',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Google Analytics',
        // @ts-ignore
        key: 'toolGoogleanalytics',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Facebook Pixel',
        // @ts-ignore
        key: 'toolFacebookpixel',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Cookiebot',
        key: 'toolCookiebot',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Cookielaw',
        key: 'toolCookielaw',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Onetrust',
        key: 'toolOnetrust',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Doubleclick',
        key: 'toolDoubleclick',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Hotjar',
        key: 'toolHotjar',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Optimizely',
        key: 'toolOptimizely',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Ebbot',
        key: 'toolEbbot',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Intercom',
        key: 'toolIntercom',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Klaviyo',
        key: 'toolKlaviyo',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Hubspot',
        key: 'toolHubspot',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Marketo',
        key: 'toolMarketo',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Salesforce',
        key: 'toolSalesforce',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Trustpilot',
        key: 'toolTrustpilot',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Custobar',
        key: 'toolCustobar',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Voyado',
        key: 'toolVoyado',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Godaddy',
        key: 'toolGodaddy',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Shopify',
        key: 'toolShopify',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool SquareSpace',
        key: 'toolSquarespace',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Wix',
        key: 'toolWix',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Wordpress',
        key: 'toolWordpress',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Seenthis',
        key: 'toolSeenthis',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Yotpo',
        key: 'toolYotpo',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Apprl',
        key: 'toolApprl',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Criteo',
        key: 'toolCriteo',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Reco',
        key: 'toolReco',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Requested hosts',
        key: 'requestedHosts',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics GTM',
        key: 'analyticsGtm',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics Aw',
        key: 'analyticsAw',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Tool Google Tag Manager',
        key: 'toolGoogletagmanager',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size document',
        key: 'sizeDocument',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size script',
        key: 'sizeScript',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size stylesheet',
        key: 'sizeStylesheet',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size image',
        key: 'sizeImage',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size media',
        key: 'sizeMedia',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Title',
        key: 'title',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Title words',
        // @ts-ignore
        key: 'titleWords',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Title chars',
        // @ts-ignore
        key: 'titleChars',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'H1 Content',
        // @ts-ignore
        key: 'h1Content',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'H1 Content Words',
        // @ts-ignore
        key: 'h1ContentWords',
        type: 'number[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'H1 Content Chars',
        // @ts-ignore
        key: 'h1ContentChars',
        type: 'number[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'H1 Count',
        // @ts-ignore
        key: 'h1Count',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'H2 Count',
        // @ts-ignore
        key: 'h2Count',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'H3 Count',
        // @ts-ignore
        key: 'h3Count',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Favicon',
        key: 'favicon',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Canonical',
        key: 'canonical',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Robots',
        key: 'robots',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'No Index (depricated)',
        key: 'noindex',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Internal links',
        key: 'internalLinks',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'External links',
        key: 'externalLinks',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics Matomo',
        key: 'analyticsMo',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Lang',
        key: 'lang',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics Adobe',
        key: 'analyticsAdobe',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Colors font',
        key: 'colorsFont',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Colors page',
        key: 'colorsPage',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Colors SVG',
        key: 'colorsSvg',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Accessibility score',
        key: 'accessViolationScore',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Accessibility violations',
        key: 'violations',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Image alt ratio',
        key: 'imgAltRatio',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics OPT',
        key: 'analyticsOpt',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics Amplitude',
        key: 'analyticsAmplitude',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Analytics Snowplow',
        key: 'analyticsSnowplow',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'Snapchat Handle',
        key: 'snapchatHandle',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Trackers before consent',
        key: 'trackersBeforeConsent',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Trackers before consent count',
        key: 'trackersBeforeConsentCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Web Vitals TTFB',
        key: 'webVitalsTtfb',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Web Vitals FCP',
        key: 'webVitalsFcp',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Web Vitals LCP',
        key: 'webVitalsLcp',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Web Vitals CLS',
        key: 'webVitalsCls',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Web Vitals TTI',
        key: 'webVitalsTti',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Web Vitals INP',
        // @ts-ignore
        key: 'webVitalsInp',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Detected languages',
        key: 'detectedLanguages',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Language count',
        key: 'languageCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Sitemap',
        key: 'sitemap',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Sitemap count',
        key: 'sitemapCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Sitemap URL count',
        key: 'sitemapUrlCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS A',
        key: 'dnsA',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS AAAA',
        key: 'dnsAaaa',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS NS',
        key: 'dnsNs',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS SOA',
        key: 'dnsSoa',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS MX',
        key: 'dnsMx',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Email Provider',
        key: 'emailProvider',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Hosting provider',
        //@ts-ignore
        key: 'hostingProvider',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Hosting region',
        //@ts-ignore
        key: 'hostingRegion',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS SPF',
        key: 'dnsSpf',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DMARC',
        key: 'dnsDmarc',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DMARC level',
        key: 'dnsDmarcLevel',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DMARC details',
        key: 'dnsDmarcDetails',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DKIM',
        key: 'dnsDkim',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DKIM selector',
        key: 'dnsDkimSelector',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DKIM level',
        key: 'dnsDkimLevel',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS DKIM details',
        key: 'dnsDkimDetails',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'DNS Verifications',
        key: 'dnsVerifications',
        type: 'string[]',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size font',
        key: 'sizeFont',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size XHR',
        key: 'sizeXhr',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size ping',
        key: 'sizePing',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size fetch',
        key: 'sizeFetch',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Size other',
        key: 'sizeOther',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'X Robots Tag',
        key: 'xRobotsTag',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Framework',
        key: 'framework',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Cookies',
        key: 'cookies',
        type: 'string',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Microdata',
        key: 'hasSchemaScript',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Image count',
        key: 'imgCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Image alt count',
        key: 'imgAltCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Image missing alt count',
        key: 'imgMissingAltCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'domain',
        translation: 'Image title count',
        key: 'imgTitleCount',
        type: 'number',
        nullable: true,
    },
    {
        section: 'handles',
        translation: 'LinkedIn is verified',
        key: 'linkedinIsVerified',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'handles',
        translation: 'LinkedIn ID',
        key: 'linkedinId',
        type: 'string',
        nullable: true,
    },
    {
        section: 'handles',
        translation: 'LinkedIn domain',
        key: 'linkedinDomain',
        type: 'string',
        nullable: true,
    },
    {
        section: 'handles',
        translation: 'LinkedIn industry',
        key: 'linkedinIndustry',
        type: 'string',
        nullable: true,
    },
    {
        section: 'handles',
        translation: 'LinkedIn number of employees',
        key: 'linkedinNumberOfEmployees',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'LinkedIn all employee growth (3M)',
        key: 'linkedinAllEmployeeGrowth3Months',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'LinkedIn all employee growth (6M)',
        key: 'linkedinAllEmployeeGrowth6Months',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'LinkedIn all employee growth (1Y)',
        key: 'linkedinAllEmployeeGrowth1Year',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'LinkedIn all employee growth (2Y)',
        key: 'linkedinAllEmployeeGrowth2Years',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Number of employees',
        key: 'numberOfEmployees',
        type: 'number',
        nullable: true,
    },
    {
        section: 'Company columns',
        translation: 'Number of employees source',
        key: 'numberOfEmployeesSource',
        type: 'string',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Count',
        key: 'companyBuzzCount',
        type: 'number',
        nullable: false,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is raising capital',
        key: 'companyBuzzIsRaisingCapital',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is IPO',
        key: 'companyBuzzIsIpo',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is merger',
        key: 'companyBuzzIsMerger',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is moving',
        key: 'companyBuzzIsMoving',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is hiring',
        key: 'companyBuzzIsHiring',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is firing',
        key: 'companyBuzzIsFiring',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is closing',
        key: 'companyBuzzIsClosing',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is opening',
        key: 'companyBuzzIsOpening',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is expanding',
        key: 'companyBuzzIsExpanding',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - is downsizing',
        key: 'companyBuzzIsDownsizing',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is restructuring',
        key: 'companyBuzzIsRestructuring',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is new product intro',
        key: 'companyBuzzIsNewProductIntro',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Has moved',
        key: 'companyBuzzHasMoved',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is changing CEO',
        key: 'companyBuzzIsChangingCeo',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is Changing Board',
        key: 'companyBuzzIsChangingBoard',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'buzz',
        translation: 'Buzz - Is changing management team',
        key: 'companyBuzzIsChangingManagementTeam',
        type: 'boolean',
        nullable: true,
    },
    {
        section: 'ml_fields',
        translation: 'ML Likely to move probability',
        key: 'mlLikelyToMoveProbability',
        type: 'number',
        nullable: true,
    },
    {
        section: 'ml_fields',
        translation: 'ML Is likely to move',
        key: 'mlIsLikelyToMove',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Move in date current office',
        key: 'moveInDateCurrentOffice',
        type: 'date',
        nullable: true,
    },
    {
        section: '',
        translation: 'Move date or lease expiration date',
        key: 'moveDateOrLeaseExpirationDate',
        type: 'date',
        nullable: true,
    },
    {
        section: '',
        translation: 'Move date or lease expiration date is within one year',
        key: 'moveDateOrLeaseExpirationDateIsWithinOneYear',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Move date or lease expiration date has passed',
        key: 'moveDateOrLeaseExpirationDateHasPassed',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Is more than 5 years since move in date current office',
        key: 'isMoreThan5YearsSinceMoveInDateCurrentOffice',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Web Visitors Lead Quality',
        key: 'nornormWebVisitorsLeadQuality',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Web Visitors Number Of Visits',
        key: 'nornormWebVisitorsNumberOfVisits',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Web Visitors Country Code',
        key: 'nornormWebVisitorsCountryCode',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Web Visitors Last Visit Date',
        key: 'nornormWebVisitorsLastVisitDate',
        type: 'date',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Web Visitors First Visit Date',
        key: 'nornormWebVisitorsFirstVisitDate',
        type: 'date',
        nullable: true,
    },
    {
        section: 'Jobposts',
        translation: 'Active jobposts per employee',
        key: 'activeJobpostsPerEmployee',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Phone',
        key: '_6SensePhone',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense City',
        key: '_6SenseCity',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Description',
        key: '_6SenseDescription',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Company Type',
        key: '_6SenseCompanyType',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Industry',
        key: '_6SenseIndustry',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Continent',
        key: '_6SenseContinent',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sence Employee Range',
        key: '_6SenceEmployeeRange',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Naics',
        key: '_6SenseNaics',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Products Or Services',
        key: '_6SenseProductsOrServices',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Sic',
        key: '_6SenseSic',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Stock Exchange',
        key: '_6SenseStockExchange',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Stock Symbol',
        key: '_6SenseStockSymbol',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Web Technologies',
        key: '_6SenseWebTechnologies',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Total Funding Range',
        key: '_6SenseTotalFundingRange',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: ' 6 Sense Year Founded',
        key: '_6SenseYearFounded',
        type: 'string',
        nullable: true,
    },
    {
        section: '',
        translation: 'Percent Employees With More Than 10 Years Experience',
        key: 'percentEmployeesWithMoreThan10YearsExperience',
        type: 'number',
        nullable: true,
    },
    {
        section: '',
        translation: 'Has On Site Requirements',
        key: 'hasOnSiteRequirements',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Recent Funding',
        key: 'recentFunding',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Keyword Search',
        key: 'nornormKeywordSearch',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Researched Office',
        key: 'nornormResearchedOffice',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Researched Furniture',
        key: 'nornormResearchedFurniture',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Looking For Office',
        key: 'lookingForOffice',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Is Sitting On CoWorking Space',
        key: 'isSittingOnCoWorkingSpace',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Lease Expiration Date',
        key: 'leaseExpirationDate',
        type: 'date',
        nullable: true,
    },
    {
        section: '',
        translation: 'Lease Expiration Date Is Within One Year',
        key: 'leaseExpirationDateIsWithinOneYear',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Nornorm Website Visitor',
        key: 'nornormWebsiteVisitor',
        type: 'boolean',
        nullable: true,
    },
    {
        section: '',
        translation: 'Number of addresses',
        key: 'numberOfAddresses',
        type: 'integer',
        nullable: true,
    },
];
//# sourceMappingURL=defined-data-fields.js.map